// Get analytics from window scope
const getAnalytics = () => {
    return (window as any).analytics;
};

export const initializeSegment = () => {
    if (!import.meta.env.VITE_ANALYTICS_KEY || import.meta.env.VITE_ANALYTICS_KEY === '') return;

    const analytics = getAnalytics();
    if (!analytics || typeof analytics.load !== 'function') return;

    analytics.load(import.meta.env.VITE_ANALYTICS_KEY);
    analytics.page();
};

export const identify = (email: string) => {
    const analytics = getAnalytics();
    if (!analytics || typeof analytics.identify !== 'function') return;

    analytics.identify(email);
};

export const track = (event: string, payload?: any) => {
    if (!import.meta.env.VITE_ANALYTICS_KEY || import.meta.env.VITE_ANALYTICS_KEY === '') return;

    const analytics = getAnalytics();
    if (!analytics || typeof analytics.track !== 'function') return;

    analytics.track(event, payload);
};

export const trackWithCallback = (event: string, payload?: any, callback?: (() => void) | undefined) => {
    const analytics = getAnalytics();
    if (!analytics || typeof analytics.track !== 'function') return;

    if (callback) {
        analytics.track(event, payload, callback);
    } else {
        // Call track directly with analytics to avoid double env check
        if (!import.meta.env.VITE_ANALYTICS_KEY || import.meta.env.VITE_ANALYTICS_KEY === '') return;
        analytics.track(event, payload);
    }
};
